import { ComposableCommerceEvents } from 'sdk/composable-commerce/types/events/ComposableCommerceEvents';
import { SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { GetProductStorePayload } from 'sdk/composable-commerce/types/payloads/CTStockPayloads';

import { GetProductStoreStockAction } from 'sdk/composable-commerce/types/actions/CTStockActions';
import { TStoreInventory } from 'shared/types/cart';

export type CTStockActions = {
  getStoreStock: GetProductStoreStockAction;
};

export const getCTStockActions = (sdk: SDK<ComposableCommerceEvents>): CTStockActions => {
  return {
    getStoreStock: async (payload: GetProductStorePayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.callAction<TStoreInventory[]>({
        actionName: 'ctstock/getStoreStock',
        payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },
  };
};
